import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cabc320"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No expenses found", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No Expenses for this month", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expense_modal = _resolveComponent("expense-modal")!
  const _component_edit_modal = _resolveComponent("edit-modal")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_expense_item = _resolveComponent("expense-item")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.expenseModal)
        ? (_openBlock(), _createBlock(_component_expense_modal, {
            key: 0,
            edit: 
        _ctx.selectedExpense && _ctx.selectedExpense.approved === null ? true : false
      ,
            isOpen: _ctx.expenseModal,
            expense: _ctx.selectedExpense,
            user: _ctx.user,
            onCloseModal: _ctx.handleCloseExpenseModal,
            onEdit: _ctx.handleEditExpense
          }, null, 8, ["edit", "isOpen", "expense", "user", "onCloseModal", "onEdit"]))
        : _createCommentVNode("", true),
      (_ctx.editModal)
        ? (_openBlock(), _createBlock(_component_edit_modal, {
            key: 1,
            isOpen: _ctx.editModal,
            categories: _ctx.categories,
            expense: _ctx.selectedExpense,
            user: _ctx.user,
            onCloseModal: _ctx.handleCloseEditModal
          }, null, 8, ["isOpen", "categories", "expense", "user", "onCloseModal"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_toolbar, { title: "My Expenses" })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, {
            style: {"margin":"0"},
            class: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                style: {"padding":"0"},
                "size-lg": "6",
                "offset-lg": "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Most recent Expenses")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.recentExpenseGroups)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentExpenseGroups, (group, i) => {
                            return (_openBlock(), _createBlock(_component_ion_item_group, {
                              key: group.date
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item_divider, {
                                  class: _normalizeClass(i === 0 ? 'no-top-margin' : ''),
                                  sticky: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.date), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.expenses, (expense, i) => {
                                  return (_openBlock(), _createBlock(_component_expense_item, {
                                    key: i,
                                    expense: expense,
                                    showStatus: "",
                                    onOpenExpenseModal: _ctx.handleOpenExpenseModal
                                  }, null, 8, ["expense", "onOpenExpenseModal"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_ion_toolbar, {
                    color: "primary",
                    style: {"margin-top":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Expenses by month")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, { class: "ion-padding" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { class: "ion-margin" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { label: "From" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Filter by month")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_datetime, {
                                onIonChange: _ctx.fetchItems,
                                displayFormat: "MMMM YYYY",
                                min: "2022-01",
                                max: 
                    `${new Date().getFullYear()}-${
                      new Date().getMonth() >= 9 ? '' : '0'
                    }${new Date().getMonth() + 1}`
                  ,
                                modelValue: _ctx.queryDate,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryDate) = $event))
                              }, null, 8, ["onIonChange", "max", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.monthlyExpenseGroups && _ctx.monthlyExpenseGroups.length)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthlyExpenseGroups, (group, i) => {
                            return (_openBlock(), _createBlock(_component_ion_item_group, {
                              key: group.date
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item_divider, {
                                  class: _normalizeClass(i === 0 ? 'no-top-margin' : ''),
                                  sticky: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.date), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.expenses, (expense, i) => {
                                  return (_openBlock(), _createBlock(_component_expense_item, {
                                    key: i,
                                    expense: expense,
                                    showStatus: "",
                                    onOpenExpenseModal: _ctx.handleOpenExpenseModal
                                  }, null, 8, ["expense", "onOpenExpenseModal"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_card, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}